<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">person</span>
      <p>
        Administra el registro de personas (pacientes) de la empresa:
        búsqueda, creación, edición, y acceso rápido a citas y notificaciones
        desde la misma pantalla.
      </p>
    </div>

    <!-- Búsqueda -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">search</span>
        Búsqueda de personas
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in busquedas" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Campos del formulario -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">edit_note</span>
        Campos del formulario
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in campos" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Acciones por fila -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Opciones por persona
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Los campos de búsqueda son mutuamente excluyentes: al escribir en
        uno se limpia el otro automáticamente. Si ambos están vacíos al
        pulsar Buscar, se recargan todos los registros de la empresa.
        Usa <strong>Detalles</strong> para acceder al perfil completo del
        paciente con alergias, vacunas y antecedentes.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaPersona",
  data() {
    return {
      busquedas: [
        {
          icon: "badge",
          titulo: "Por cédula",
          desc:   "Ingresa el número de documento del paciente y presiona Enter o el botón de búsqueda para filtrar los resultados.",
        },
        {
          icon: "person_search",
          titulo: "Por nombre",
          desc:   "Escribe parte del nombre completo del paciente y presiona Enter o el botón de búsqueda para encontrar los registros coincidentes.",
        },
        {
          icon: "list_alt",
          titulo: "Todos los registros",
          desc:   "Pulsa el botón de recarga para ver todos los pacientes registrados en la empresa sin aplicar filtros.",
        },
      ],
      campos: [
        {
          icon: "badge",
          titulo: "Tipo de identificación y documento",
          desc:   "Selecciona el tipo de documento (cédula, pasaporte, etc.) e ingresa el número. Es el identificador único del paciente.",
        },
        {
          icon: "favorite",
          titulo: "Estado civil",
          desc:   "Estado civil del paciente seleccionado del catálogo del sistema.",
        },
        {
          icon: "cake",
          titulo: "Fecha de nacimiento y sexo",
          desc:   "Fecha de nacimiento en formato de calendario y sexo biológico del paciente. Ambos son obligatorios.",
        },
        {
          icon: "phone",
          titulo: "Teléfono",
          desc:   "Número de contacto principal del paciente.",
        },
        {
          icon: "person",
          titulo: "Nombres y apellidos",
          desc:   "Primer nombre, segundo nombre, primer apellido y segundo apellido. Todos en mayúsculas. Los campos primero son obligatorios.",
        },
        {
          icon: "location_on",
          titulo: "Localidad y dirección",
          desc:   "Localidad del catálogo del sistema y dirección de domicilio completa del paciente.",
        },
        {
          icon: "email",
          titulo: "Email",
          desc:   "Correo electrónico del paciente. Se usa para envío de documentos y notificaciones.",
        },
        {
          icon: "expand_more",
          titulo: "Más información",
          desc:   "Despliega la fecha de registro del paciente en el sistema (solo lectura).",
        },
      ],
      acciones: [
        {
          icon:   "edit",
          color:  "#0059cc",
          titulo: "Editar",
          desc:   "Abre el formulario modal con los datos actuales del paciente para modificar cualquier campo.",
        },
        {
          icon:   "open_in_new",
          color:  "#198754",
          titulo: "Detalles",
          desc:   "Navega al perfil completo del paciente donde se puede gestionar alergias, vacunas, antecedentes y más información clínica.",
        },
        {
          icon:   "delete",
          color:  "#dc3545",
          titulo: "Borrar",
          desc:   "Elimina el registro del paciente previa confirmación. Esta acción es permanente.",
        },
        {
          icon:   "calendar_month",
          color:  "#0059cc",
          titulo: "Nueva cita",
          desc:   "Inicia el asistente de creación de citas con el paciente preseleccionado.",
        },
        {
          icon:   "notifications",
          color:  "#fd7e14",
          titulo: "Nueva notificación",
          desc:   "Abre el formulario para registrar una notificación o bitácora de comunicación con el paciente.",
        },
        {
          icon:   "add_circle",
          color:  "#0059cc",
          titulo: "Nueva persona",
          desc:   "Abre el formulario modal para registrar un nuevo paciente en la empresa.",
        },
        {
          icon:   "download",
          color:  "#fd7e14",
          titulo: "Exportar Excel",
          desc:   "Descarga la lista actual de pacientes en formato Excel.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>